import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import {
  mapPlaylistCardToContentCardAction,
  mapPlaylistCardToContentCardItem,
  openPlaylistCard,
} from '@app/app/shared/collections/card-item/card-item-content-card.mapper';
import { V3ContentCardComponent } from '@app/app/shared/components-v3/content-card/v3-content-card.component';
import { PlaylistCardShort } from '@app/app/shared/models';
import { IconComponent } from '@app/app/shared/styleguide/components/icon/icon.component';
import { LucideCheck } from '@lucide/angular';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'ptl-card-item-snake-view',
  standalone: true,
  imports: [IconComponent, V3ContentCardComponent],
  templateUrl: './card-item-snake-view.component.html',
  styleUrls: ['./card-item-snake-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardItemSnakeViewComponent {
  private readonly transloco = inject(TranslocoService);

  card = input.required<PlaylistCardShort>();
  cardIndex = input(0);

  cardClick = output<PlaylistCardShort>();

  protected readonly LucideCheck = LucideCheck;

  protected readonly cardItem = computed(() => mapPlaylistCardToContentCardItem(this.card(), this.cardIndex(), this.transloco));

  protected readonly action = computed(() => mapPlaylistCardToContentCardAction(this.card(), this.transloco));

  onCardOpen(): void {
    openPlaylistCard(this.card(), (card) => this.cardClick.emit(card));
  }
}
